export const environment = {
    name: 'prod',
    production: 'true',
    endpoint: 'https://api.decamoney.com/',
    rate_enpoint: 'https://production-rate-service.herokuapp.com',
    timeStamp: '30/05/2021'
  };
